import React, { FC, useEffect } from "react";
import { ConnectedProps, connect } from "react-redux";
import { Label, Link, Text } from "@fluentui/react-components";

import { IRapComponentProperties } from "../../../../platform/Layout";
import { IUhfViewState } from "../../../../pages/Contracts";
import { ITestConfiguration } from "../../Contracts";
import { TestActions } from "../../redux/TestActions";
import { constructUHFLoaderUrl, constructUHFUrl } from "../../../../common/UHFHelper";
import { localizedStrings } from "../../../../common/localization/LocalizedStrings";

import * as TestSelectors from "../../redux/TestSelectors";

import "./LinkConfigurator.scss";
import { UHFLinkType } from "../../../../common/Constants";



interface ILinkConfiguratorProvidedProps extends IRapComponentProperties {
    className?: string;
}

interface ILinkConfiguratorOwnProps {
    testConfig: ITestConfiguration;
}

export type ILinkConfiguratorProps = ConnectedProps<typeof connector> & ILinkConfiguratorProvidedProps;

const LinkConfiguratorInitializer: FC<ILinkConfiguratorProps> = (props) => {
    useEffect(() => {
        props.setTestConfig(
            { 
                links: {
                    serviceUrl: constructUHFUrl(
                        props.testConfig.partnerId, 
                        props.testConfig.locale, 
                        props.testConfig.environment, 
                        props.testConfig.options,
                        UHFLinkType.XML,
                        props.testConfig.headerId, 
                        props.testConfig.footerId
                    ),
                    serviceDemoUrl: constructUHFUrl(
                        props.testConfig.partnerId, 
                        props.testConfig.locale, 
                        props.testConfig.environment, 
                        props.testConfig.options,
                        UHFLinkType.HTML,
                        props.testConfig.headerId, 
                        props.testConfig.footerId
                    ),
                    previewUrl: constructUHFLoaderUrl(
                        props.testConfig.partnerId, 
                        props.testConfig.locale, 
                        props.testConfig.environment,
                        props.testConfig.options,
                        props.testConfig.headerId, 
                        props.testConfig.footerId
                    )
                }
            });
    }, [props.testConfig?.partnerId, props.testConfig?.headerId, props.testConfig?.footerId, props.testConfig?.locale, props.testConfig.environment, props.testConfig.options])

    return (
        <div className={`${props.className ? props.className : ""} c-linkConfigurator`}>
            {props.testConfig.options.vNext && (
                <div className="c-warning">
                    <Text>WARNING: UHF vNext is currently in active development and should NOT be used in production environments</Text>
                </div>
            )}
            <Label>{localizedStrings.TestView?.TestConfigurator?.serviceLink}</Label>
            <Link href={props.testConfig?.links?.serviceUrl}>{props.testConfig?.links?.serviceUrl}</Link>
        </div>
    )
}

function mapStateToProps(state: IUhfViewState, providedProps: ILinkConfiguratorProvidedProps): Partial<ILinkConfiguratorOwnProps> {
    return {
        ...providedProps,
        testConfig: TestSelectors.getTestConfig(state)
    };
}

const ActionsToDispatch = {
    setTestConfig: TestActions.setTestConfig
};

const connector = connect(
    mapStateToProps,
    ActionsToDispatch,
    null,
    { forwardRef: true }
);

export const LinkConfigurator = connector(LinkConfiguratorInitializer);